import React, {Component} from 'react';
import {observer} from "mobx-react";

import Embed from "./Attachments/Embed";
import Image from "./Attachments/Image";
import Gallery from "./Attachments/Gallery";
import MyPhotos from "./Attachments/MyPhotos";
import TenorGif from "./Attachments/TenorGif";

class CommentAttachments extends Component {
  render() {
    if(!this.props.attachments || this.props.attachments.length === 0) {
      return null;
    }
    return (
      <div>
        {this.props.attachments.map((item,index)=>{
          switch(item.type) {
            case "image":
                return <Image key={index} data={item} />
              break;
            case "gallery":
              return <Gallery key={index} data={item} />
              break;
            case "myphotos":
              return <MyPhotos key={index} data={item} />
              break;
            case "embed":
              return <Embed key={index} data={item} />
              break;
            case "tenorgif":
              return <TenorGif key={index} data={item} />
              break;
          }
        })}
      </div>
    )
  }
}

export default observer(CommentAttachments);